import axios from '@/utils/request'

const agentUserManagementUrl = '/data/user/agent/agentUserManagement'
const agentUserManagement = async (body) => {
  const { data } = await axios.post(agentUserManagementUrl, body)
  return data.data
}

const agentUserManagementEditUrl = '/data/user/agent/agentUserManagementEdit'
const agentUserManagementEdit = async (body) => {
  const { data } = await axios.post(agentUserManagementEditUrl, body)
  return data.data
}

const rateEditUrl = '/data/user/agent/updateRate'
const rateEdit = async (body) => {
  const { data } = await axios.post(rateEditUrl, body)
  return data.data
}

const needLoginUrl = []

export default {
  needLoginUrl,
  agentUserManagement,
  agentUserManagementEdit,
  rateEdit,
}
